module.exports = __webpack_public_path__ + "static/media/Aveny soffa 2-sits 3-sits liver calypso tex-bull dark brown miljö 2023.f912d52c.jpg";